import type { ProjectionItem } from '../store/schema/PopoutParentStore';
import { PROJECTION_ROOT_ID, PROJECTION_LOADING_ID } from './constants';

export function getProjectionRoot(
    projection: ProjectionItem | undefined
): HTMLElement | null | undefined {
    return projection?.window.document.getElementById(PROJECTION_ROOT_ID);
}

export function getProjectionLoading(projection: ProjectionItem): HTMLElement | null {
    return projection?.window.document.getElementById(PROJECTION_LOADING_ID);
}
